import React, { useEffect } from 'react';

type Props = {
  url: string;
};

const Redirect: React.FC<Props> = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <span />;
};

export default Redirect;
